import { createUseStyles } from 'react-jss'

import { tabletDown } from '../../../../styles/const/breakpoints'

export const gap = 40

const useStyles = createUseStyles({
  graphsContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, calc((100% - 40px) / 2))',
    gridGap: gap,
    marginTop: gap
  },
  fullWidthGraphsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: gap,
    marginTop: gap
  },
  errorMessage: {
    textAlign: 'center',
    marginTop: gap
  },
  [`@media screen and (${tabletDown})`]: {
    graphsContainer: {
      display: 'flex',
      flexDirection: 'column'
    }
  }
})

export default useStyles
